import { useCallback } from 'react';

import { DEFAULT_THEME, THEME_ENUM } from '@/constants';
import { LOCAL_THEME } from '@/constants/storage';
import { useTheme } from '@/features/global/hooks';
import useTradingViewTheme from '@/pages/components/TradingViewPro/hooks/useTradingViewTheme';

export function useSwitchTheme(): () => void {
  const { setDataTheme } = useTheme();
  const { changeTvTheme } = useTradingViewTheme();
  const getTheme = () => {
    return (localStorage.getItem(LOCAL_THEME) || DEFAULT_THEME) as THEME_ENUM;
  };
  const onThemeToggle = useCallback(() => {
    const themeMap = {
      [THEME_ENUM.DARK]: THEME_ENUM.LIGHT,
      [THEME_ENUM.LIGHT]: THEME_ENUM.DARK,
    };
    const currTheme = themeMap[getTheme()];
    localStorage.setItem(LOCAL_THEME, currTheme);

    document.documentElement.setAttribute('data-theme', currTheme);
    setDataTheme(currTheme);
    changeTvTheme(currTheme);
  }, [setDataTheme, changeTvTheme]);
  return onThemeToggle;
}
